import { render, staticRenderFns } from "./StakingReward.vue?vue&type=template&id=d2fc37be&"
import script from "./StakingReward.vue?vue&type=script&lang=js&"
export * from "./StakingReward.vue?vue&type=script&lang=js&"
import style0 from "./StakingReward.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports